import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, tap } from 'rxjs';

import { jwtDecode } from "jwt-decode"
import { LoginPayload, LoginResponse } from '../models/auth.model';
import { BaseService } from './base.service';
import { LocalStorageKeys } from '../utils/local-storage-keys.enum';

@Injectable({
  providedIn: 'root',
})
export class AuthService extends BaseService {
  private readonly tokenKey = 'user';

  constructor(http: HttpClient) {
    super(http);
  }

  login(payload: LoginPayload): Observable<LoginResponse> {
    return this.http
      .post<LoginResponse>(`${this.baseUrl}/backoffice/authentication/authenticate`, this.encrypt(payload))
      .pipe(
        map(this.extractData),
        tap((response) => {

          this.setAuthenticatedUser(response);

          if (response.user) {
            localStorage.setItem('user', JSON.stringify(response.user));
          }
        }),
        catchError((error) => this.serviceError(error)),
      );
  }

  getToken(): string | null {
    return localStorage.getItem(this.tokenKey);
  }

  isAuthenticated(): boolean {
    return !!this.getToken();
  }

  logout(): void {
    localStorage.removeItem(this.tokenKey);
    localStorage.removeItem('user');
  }

  setAuthenticatedUser(dto: any) {
    if (dto.token) {
      const decoded: any = jwtDecode(dto.token);
      dto.email = decoded.email;
      dto.name = decoded.name;
      dto.role = decoded.role;
      dto.permissions = decoded.permissions;
      dto.firstAccess = decoded.firstAccess;
      dto._id = decoded.userId;
      dto.id = decoded.userId;
    }
    localStorage.setItem(LocalStorageKeys.user, JSON.stringify(dto));
  }


  getAuthenticatedUser() {
    const user = localStorage.getItem(LocalStorageKeys.user);
    return user === null ? undefined : JSON.parse(user);
  }

  removeAuthenticatedUser() {
    localStorage.removeItem(LocalStorageKeys.user);
  }

  isTokenValid(token: string): boolean {
    if (!token) {
      return false;
    }
    try {
      const decoded: any = jwtDecode(token);
      if (!decoded.exp) {
        return false;
      }
      const currentTime = Math.floor(Date.now() / 1000);
      return decoded.exp > currentTime;
    } catch (error) {
      console.error('Erro ao decodificar o token:', error);
      return false;
    }
  }

  tfaRegisteredVerify(): boolean {
    const user = this.getAuthenticatedUser();
    if(!user) {
      return false;
    }

    const token = user.token;
    if (!token) {
      return false;
    }
    const decoded: any = jwtDecode(token);
    
    if (!decoded?.tfaRegistered) {
      return false;
    } else {
      return true
    }
  }

  tfaRegisteredAndAuthenticatedVerify(): boolean {
    const user = JSON.parse(localStorage.getItem('user')!);
    const token = user.token;
    if (!token) {
      return false;
    }
    const decoded: any = jwtDecode(token);
    if (!decoded?.tfaRegistered || !decoded?.tfaAuthenticate) {
      return false;
    } else {
      return true
    }
  }
}